import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import { getFormattedTime } from "utils/utils";

const StyledSlider = withStyles({
  root: {
    color: "#323232",
    height: 3,
    padding: "13px 0",
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: "#fff",
    border: "1px solid currentColor",
    marginTop: -8,
    marginLeft: -9,
    "& .bar": {
      // display: inline-block !important;
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  active: {},
  track: {
    height: 3,
    color: "#28bf8f",
  },
  rail: {
    color: "gray",
    opacity: 1,
    height: 3,
  },
})(Slider);

export default function ClipTracker(props) {
  return (
    <div>
      <StyledSlider
        valueLabelDisplay="auto"
        key="CLIP-TRACKER"
        min={props.min}
        max={props.max}
        value={props.value}
        onChange={props.handleChange}
        onChangeCommitted={props.commitTrackerChange}
        aria-labelledby="range-slider"
        getAriaValueText={getFormattedTime}
        step={0.01}
        onMouseDown={props.handleMouseDown}
      />
    </div>
  );
}
